var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',[_c('strong',[_vm._v(_vm._s(_vm.recipient))]),_c('br'),_vm._v(" "+_vm._s(_vm.address)),_c('br'),_vm._v(" "+_vm._s(_vm.postalcode)),_c('br'),_vm._v(" "+_vm._s(_vm.city)),_c('br'),_vm._v(" "+_vm._s(_vm.country)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }